<li class="nav-item bs-dropdown d-sm-down-none user-bar-nav" placement="bottom right">
  <a
    class="bs-nav-link inline-flex items-center font-semibold transition-colors duration-150 hover:text-[var(--navbar-hover-color)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--navbar-hover-color)]"
    data-toggle="dropdown"
    role="button"
    style="cursor: default;"
  >
    <i class="fa fa-user-circle navbar-action-icon"></i>
    <span class="navbar-action-label">{{userDisplayName$ | async}}</span>
  </a>
</li>
